module.exports = __webpack_public_path__ + "img/api-2.79a2e923.png";